module.exports = __webpack_public_path__ + "static/media/Kaethe Selkirk.0edf60cf.png";